import React from 'react';

import styles from './Filters.module.scss';
import {
    AGENCY_PROJECT,
    PROJECT_CAR,
    PROJECT_CRI,
    PROJECT_CSV,
    PROJECT_GRA,
    TC_EVENT_NAMES,
    CAR_CERTIFICATIONS
} from '../utils/Constants';
import FilterSetting from './FilterSetting';
import FloatingToggleButton from './FloatingToggleButton';
import Icon from './Icon';
import Modal from './Modal';
import { useDeviceDetection } from '../utils/DeviceDetection';
import SlidingPanel from './SlidingPanel';
import { useTCLog } from '../utils/TCEvent';
import { SHOW_ALL, TABS_TO_DISPLAY } from '../api/portletConfiguration';

export default function Filters({
    show,
    searchFor,
    filters,
    onFiltersChange,
    onToggleFilters
}) {
    const [TCLog, setTCAppData] = useTCLog();
    const isMobile = useDeviceDetection();

    function getLast(project) {
        let last;
        for (let prop in project) {
            if (project[prop]) {
                if (!last) {
                    last = prop;
                } else {
                    return null;
                }
            }
        }
        return last;
    }

    function handleClick(project, key) {
        const newFilters = { ...filters };

        for (let i = 0; i < newFilters[project].length; i++) {
            const filter = newFilters[project][i];

            if (filter.key == key) {
                filter.value = !filter.value;
            }
        }
        onFiltersChange(newFilters);
    }

    const filterContent = (
        <>
            <h3>Filtri</h3>
            <p>
                Seleziona i risultati che desideri visualizzare in base alle tue
                esigenze
            </p>
            <div className={styles.filtersContainer}>
                {/* Filtri Agenzie */}
                {searchFor == AGENCY_PROJECT ||
                (SHOW_ALL && TABS_TO_DISPLAY.includes(AGENCY_PROJECT)) ? (
                    <div className={styles.filterSetting}>
                        <h5>Seleziona agenzie</h5>
                        {filters[AGENCY_PROJECT].map((filter) => (
                            <FilterSetting
                                text={filter.label}
                                icon={
                                    <Icon
                                        icon={filter.icon}
                                        size="small"
                                        textOn="right"
                                        className={styles.icon}
                                    />
                                }
                                number={filter.resultsNumber}
                                onClick={() => {
                                    TCLog(
                                        filter.key == AGENCY_PROJECT
                                            ? TC_EVENT_NAMES.FILTER_AGENCY
                                            : TC_EVENT_NAMES.FILTER_SUBAGENCY,
                                        null,
                                        'filter',
                                        !filter.value
                                    );
                                    handleClick(AGENCY_PROJECT, filter.key);
                                }}
                                checked={filter.value}
                                disabled={
                                    filter.key == AGENCY_PROJECT ? true : false
                                }
                                key={filter.key}
                            />
                        ))}
                    </div>
                ) : null}
                {/* Filtri Carrozzerie */}
                {searchFor == PROJECT_CAR ||
                (SHOW_ALL && TABS_TO_DISPLAY.includes(PROJECT_CAR)) ? (
                    <div className={styles.filterSetting}>
                        <h5>Seleziona carrozzerie</h5>

                        {filters[PROJECT_CAR].map((filter) => {
                            // Evita di stampare in questo blocco le certificazioni BMW
                            if (CAR_CERTIFICATIONS.find(c => c.name === filter.key)) return null;
                            
                            return (
                                <FilterSetting
                                    text={filter.label}
                                    icon={
                                        <Icon
                                            icon={filter.icon}
                                            size="small"
                                            textOn="right"
                                            className={styles.icon}
                                        />
                                    }
                                    number={filter.resultsNumber}
                                    onClick={() =>
                                        handleClick(PROJECT_CAR, filter.key)
                                    }
                                    checked={filter.value}
                                    disabled={
                                        getLast(filters[PROJECT_CAR]) == filter.key
                                    }
                                    key={filter.key}
                                />
                            )
                        })}
                    </div>
                ) : null}

                {/* Filtri Certificazioni Carrozzerie (BMW/MINI) */}
                {searchFor == PROJECT_CAR ||
                (SHOW_ALL && TABS_TO_DISPLAY.includes(PROJECT_CAR)) ? (
                    <div className={styles.filterSetting}>
                        <h5>Certificazioni e Servizi</h5>

                        {CAR_CERTIFICATIONS.map((cert) => {
                            const filterState = filters[PROJECT_CAR]?.find(f => f.key === cert.name);
                            if (!filterState) return null; // Se il genitore non ha passato lo stato, non stamparlo

                            return (
                                <FilterSetting
                                    text={cert.name}
                                    icon={
                                        <Icon
                                            icon={cert.icon}
                                            size="small"
                                            textOn="right"
                                            className={styles.icon}
                                        />
                                    }
                                    number={filterState.resultsNumber}
                                    onClick={() =>
                                        handleClick(PROJECT_CAR, cert.name)
                                    }
                                    checked={filterState.value}
                                    key={cert.name}
                                />
                            );
                        })}
                    </div>
                ) : null}

                {/* Filtri Cristalli */}
                {searchFor == PROJECT_CRI ||
                (SHOW_ALL && TABS_TO_DISPLAY.includes(PROJECT_CRI)) ? (
                    <div className={styles.filterSetting}>
                        <h5>Seleziona centri cristalli</h5>

                        {filters[PROJECT_CRI].map((filter, index) => {
                            return (
                                <>
                                    <FilterSetting
                                        text={filter.label}
                                        icon={
                                            <Icon
                                                icon={filter.icon}
                                                size="small"
                                                textOn="right"
                                                className={styles.icon}
                                            />
                                        }
                                        number={filter.resultsNumber}
                                        onClick={() =>
                                            handleClick(PROJECT_CRI, filter.key)
                                        }
                                        checked={filter.value}
                                        disabled={
                                            getLast(filters[PROJECT_CRI]) ==
                                            filter.key
                                        }
                                        key={filter.key}
                                    />
                                </>
                            );
                        })}
                    </div>
                ) : null}
                {/* Filtri Grandine */}
                {searchFor == PROJECT_GRA ||
                (SHOW_ALL && TABS_TO_DISPLAY.includes(PROJECT_GRA)) ? (
                    <div className={styles.filterSetting}>
                        <h5>Seleziona centri grandine</h5>

                        {filters[PROJECT_GRA].map((filter) => (
                                    <FilterSetting
                                        text={filter.label}
                                        icon={
                                            <Icon
                                                icon={filter.icon}
                                                size="small"
                                                textOn="right"
                                                className={styles.icon}
                                            />
                                        }
                                        number={filter.resultsNumber}
                                        onClick={() =>
                                            handleClick(PROJECT_GRA, filter.key)
                                        }
                                        checked={filter.value}
                                        disabled={
                                            getLast(filters[PROJECT_GRA]) ==
                                            filter.key
                                        }
                                        key={filter.key}
                                    />
                        ))}
                    </div>
                ) : null}
                {/* Filtri Centri Salute */}
                {searchFor == PROJECT_CSV ||
                (SHOW_ALL && TABS_TO_DISPLAY.includes(PROJECT_CSV)) ? (
                    <div className={styles.filterSetting}>
                        <h5>Seleziona centri salute</h5>

                        {filters[PROJECT_CSV].map((filter) => (
                            <FilterSetting
                                text={filter.label}
                                icon={
                                    <Icon
                                        icon={filter.icon}
                                        size="small"
                                        textOn="right"
                                        className={styles.icon}
                                    />
                                }
                                number={filter.resultsNumber}
                                onClick={() =>
                                    handleClick(PROJECT_CSV, filter.key)
                                }
                                checked={filter.value}
                                disabled={
                                    getLast(filters[PROJECT_CSV]) == filter.key
                                }
                                key={filter.key}
                            />
                        ))}
                    </div>
                ) : null}
            </div>
        </>
    );

    return !isMobile ? (
        <Modal show={show} onClose={onToggleFilters}>
            {filterContent}
        </Modal>
    ) : (
        <SlidingPanel show={show} variant="secondary" onClose={onToggleFilters}>
            {filterContent}
        </SlidingPanel>
    );
}